import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const LawFinderDefaultWidget = (props) => {
  return (
    <DefaultWidgetTemplate
      module={props.module}
      route="user_module_lawFinder_home"
    />
  );
};

export default LawFinderDefaultWidget;
